import React from 'react';
import DateAndTimeReadonly from '../DateAndTimeReadonly';
import { TimeEntryProps } from '../../../../Projects/types';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';
import DurationFormat from '../../../../../components/DurationFormat';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';

type DayTrackedInfoProps = {
  timeEntries: TimeEntryProps[];
  i18prefix: string;
};

const DayTrackedInfo: React.FC<
  React.PropsWithChildren<DayTrackedInfoProps>
> = ({ timeEntries, i18prefix }) => {
  const t = useNamespacedTranslation(i18prefix);
  const earliestStartTime = Math.min(
    ...timeEntries
      .map((timeEntry) => timeEntry.startDatetime)
      .map((startTime) => startTime.getTime()),
  );

  const endTimes = timeEntries
    .map((timeEntry) => timeEntry.endDatetime)
    .filter((endTime) => endTime !== null)
    .map((endTime) => endTime.getTime());

  const latestEndTime = endTimes.length > 0 ? Math.max(...endTimes) : null;

  const breakTime =
    timeEntries
      .map((timeEntry) => {
        return timeEntry.totalBreakPeriodInHours;
      })
      .reduce((sum, current) => sum + current, 0) * 60;

  const notes = timeEntries
    .map((timeEntry) => timeEntry.notes)
    .filter((note) => note !== null)
    .join('\n');

  return (
    <>
      <div className="mb-2 row">
        <div className="col-lg-1 col-1">
          <label className="mb-0 form-label">
            {t('dayTrackedInfo.startTime')}
          </label>
        </div>
        <div className="col-lg-2 col-2">
          <label className="mb-0 form-label">
            {t('dayTrackedInfo.endTime')}
          </label>
        </div>
        <div className="col-lg-1 col-1">
          <label className="mb-0 form-label">
            {t('dayTrackedInfo.breakTime')}
          </label>
        </div>
        {notes && (
          <div className="col-lg-4 col-5">
            <label className="mb-0 form-label">
              {t('dayTrackedInfo.notes')}
            </label>
          </div>
        )}
      </div>

      <div className="mb-2 row">
        <div className="col-lg-1 col-1">
          <DateAndTimeReadonly
            value={{
              date: new Date(earliestStartTime).toISOString(),
              time: new Date(earliestStartTime).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              }),
            }}
            isDateVisible={false}
          />
        </div>
        <div className="col-lg-2 col-2">
          {latestEndTime && (
            <DateAndTimeReadonly
              value={{
                date: new Date(latestEndTime).toISOString(),
                time: new Date(latestEndTime).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                }),
              }}
              isDateVisible={false}
            />
          )}
        </div>
        <div className="col-lg-1 col-1 d-flex align-items-center">
          <FlairIcon icon="cafe-outline" className="me-1" />
          <DurationFormat minutes={breakTime} />
        </div>
        {notes && <div className="col-lg-4 col-5">{notes}</div>}
      </div>
    </>
  );
};

export default DayTrackedInfo;
